import * as React from "react";
import { TableDataRowProps } from "../../../Common/UI/Index";
import { Table } from "../../../Common/UI/Index";
import { PopulateCustomTable } from "./ColumnDefinition";
import "./Style.scss";

interface ExtractVersionTableView {
  /**
   * Version list to be displayed in table
   */
  versionList: TableDataRowProps[];
}

/**
 * Responsible for rendering the version table component
 */
export const VersionTableView: React.FC<ExtractVersionTableView> = (props: ExtractVersionTableView) => {
  const { versionList } = props;
  return (
    <div>
      <Table
        id="versionTableId"
        tableData={PopulateCustomTable(versionList)}
        emptyStateText="No entries found"
        className="ebt-extract-version__list"
        data-testid="ebt-extract-version"
      />
    </div>
  );
};
